/*
  FSO Gizli Portre Stüdyosu — "Gözünü Kıs" ürünleri (sanat-eseri şablonu, art_engine = gizli_portre).

  Müşteri fotoğrafını yükler → tarayıcıda yüzler ve kişi silüeti bulunup gri "gizli desen" hazırlanır (fotoğrafın kendisi
  gönderilmez; kişilerin arkası düz koyu zemine indirilir, yoksa arka plandaki kemer/pencere tabloda altın çerçeveye dönüşüyor)
  → sunucu (portre.forspaceon.com, gizli-portre-sunucu/) ControlNet illusion ile tabloyu üretir (~10–30 sn)
  → önizleme galeride (masaüstü) / kartın içinde (mobil) çerçeveli görünür; "Tekrar dene" yeni bir varyasyon üretir,
  önceki denemeler küçük resimlerden geri seçilebilir → sepete eklerken seçili tasarımın 33×48 PDF bağlantısı
  sipariş satırına gizli özellik olarak yazılır (_tasarim_pdf, _tasarim_onizleme, _stil).

  Kurulum: sayfada <div data-fso-gp> + içinde <script type="application/json" data-fso-gp-ayar>{...}</script>.
  Ayarlar: api, stil, form (form seçicisi), medya (sol sütun seçicisi), galeri (gizlenecek ürün galerisi),
           renk (seçili çerçeve rengi düğmesi seçicisi), kok (gözünü kıs sınıfının bağlandığı kök), bulaniklik (px),
           kvkk (bağlantı), metinler {...}
*/
(function () {
  'use strict';

  /* =====================================================================
     1) Ön işleme: fotoğraf → 768×1120 gri, 4 tonlu "gizli desen"
        (prototip/gizli-portre/on-isleme.js ile aynı ayarlar)
     ===================================================================== */
  var MP_SURUM = '0.10.14';
  var algilayiciSozu = null, ayiriciSozu = null, visionSozu = null;

  function visionYukle() {
    if (!visionSozu) {
      visionSozu = (async function () {
        var vision = await import('https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision@' + MP_SURUM + '/vision_bundle.mjs');
        var dosyalar = await vision.FilesetResolver.forVisionTasks('https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision@' + MP_SURUM + '/wasm');
        return { vision: vision, dosyalar: dosyalar };
      })();
      visionSozu.catch(function () { visionSozu = null; });
    }
    return visionSozu;
  }

  // Kişi ayırma (selfie segmenter): kişilerin arkasındaki kemer, pencere, bina gibi şekiller desende kalırsa
  // model onları altın çerçeve/süslemeye çeviriyor; arka plan bu maskeyle düz koyu zemine indirilir.
  function ayirici() {
    if (!ayiriciSozu) {
      ayiriciSozu = (async function () {
        var v = await visionYukle();
        return v.vision.ImageSegmenter.createFromOptions(v.dosyalar, {
          baseOptions: { modelAssetPath: 'https://storage.googleapis.com/mediapipe-models/image_segmenter/selfie_segmenter/float16/latest/selfie_segmenter.tflite' },
          runningMode: 'IMAGE',
          outputCategoryMask: false,
          outputConfidenceMasks: true,
        });
      })();
      ayiriciSozu.catch(function () { ayiriciSozu = null; });
    }
    return ayiriciSozu;
  }

  async function kisiMaskesi(img) {
    try {
      var seg = await zamanAsimi(ayirici(), 15000);
      var r = seg.segment(img);
      var m = r.confidenceMasks && r.confidenceMasks[0];
      if (!m) return null;
      var sonuc = { veri: Float32Array.from(m.getAsFloat32Array()), w: m.width, h: m.height };
      if (r.close) r.close();
      return sonuc;
    } catch (e) {
      console.warn('[gizli-portre] Kişi ayırma çalışmadı, arka plan yalnız karartılıyor', e);
      return null;
    }
  }

  function algilayici() {
    if (!algilayiciSozu) {
      algilayiciSozu = (async function () {
        var v = await visionYukle();
        var vision = v.vision, dosyalar = v.dosyalar;
        return vision.FaceDetector.createFromOptions(dosyalar, {
          baseOptions: { modelAssetPath: 'https://storage.googleapis.com/mediapipe-models/face_detector/blaze_face_short_range/float16/1/blaze_face_short_range.tflite' },
          runningMode: 'IMAGE',
          minDetectionConfidence: 0.5,
        });
      })();
      algilayiciSozu.catch(function () { algilayiciSozu = null; });
    }
    return algilayiciSozu;
  }

  function zamanAsimi(soz, ms) {
    return Promise.race([soz, new Promise(function (_, red) { setTimeout(function () { red(new Error('zaman aşımı')); }, ms); })]);
  }

  async function yuzleriBul(img) {
    try {
      var fd = await zamanAsimi(algilayici(), 15000);
      var r = fd.detect(img);
      return (r.detections || []).map(function (d) {
        var b = d.boundingBox;
        return { x: b.originX, y: b.originY, w: b.width, h: b.height, skor: d.categories && d.categories[0] ? d.categories[0].score : 0 };
      }).filter(function (f) { return f.skor >= 0.5 && f.w > 24; });
    } catch (e) {
      console.warn('[gizli-portre] Yüz algılama çalışmadı, ortadan kırpılıyor', e);
      return null;
    }
  }

  function bulanik(src, w, h, r) {
    r = Math.max(1, Math.round(r));
    var tmp = new Float32Array(src.length);
    var a = Float32Array.from(src);
    var iarr = 1 / (r + r + 1);
    for (var g = 0; g < 3; g++) {
      for (var y = 0; y < h; y++) {
        var o = y * w, fv = a[o], v = (r + 1) * fv;
        for (var j = 0; j < r; j++) v += a[o + Math.min(j, w - 1)];
        for (var x = 0; x < w; x++) {
          v += a[o + Math.min(x + r, w - 1)] - (x - r - 1 >= 0 ? a[o + x - r - 1] : fv);
          tmp[o + x] = v * iarr;
        }
      }
      for (var x2 = 0; x2 < w; x2++) {
        var fv2 = tmp[x2], v2 = (r + 1) * fv2;
        for (var j2 = 0; j2 < r; j2++) v2 += tmp[Math.min(j2, h - 1) * w + x2];
        for (var y2 = 0; y2 < h; y2++) {
          v2 += tmp[Math.min(y2 + r, h - 1) * w + x2] - (y2 - r - 1 >= 0 ? tmp[(y2 - r - 1) * w + x2] : fv2);
          a[y2 * w + x2] = v2 * iarr;
        }
      }
    }
    return a;
  }

  function yuzdelik(degerler, p) {
    var k = new Uint32Array(256);
    for (var i = 0; i < degerler.length; i++) k[Math.max(0, Math.min(255, degerler[i] | 0))]++;
    var hedef = degerler.length * p, t = 0;
    for (var v = 0; v < 256; v++) { t += k[v]; if (t >= hedef) return v; }
    return 255;
  }

  async function desenHazirla(img) {
    var W = 768, H = 1120;
    var fw = img.naturalWidth || img.width, fh = img.naturalHeight || img.height;
    var bulunan = await yuzleriBul(img);
    var yuzler = bulunan || [];
    var hamMaske = await kisiMaskesi(img);

    // Kırpma: yüzlerin birleşim kutusu genişliğin ~%86'sı, merkezi yüksekliğin ~%42'si
    var cx = fw / 2, cy = fh / 2, kw;
    if (yuzler.length) {
      var x0 = Math.min.apply(null, yuzler.map(function (f) { return f.x; }));
      var x1 = Math.max.apply(null, yuzler.map(function (f) { return f.x + f.w; }));
      var y0 = Math.min.apply(null, yuzler.map(function (f) { return f.y; }));
      var y1 = Math.max.apply(null, yuzler.map(function (f) { return f.y + f.h; }));
      cx = (x0 + x1) / 2; cy = (y0 + y1) / 2;
      var kutuW = Math.max(x1 - x0, (y1 - y0) * 0.9);
      kw = Math.max(kutuW / 0.86, Math.max.apply(null, yuzler.map(function (f) { return f.w; })) * 1.9);
    } else {
      kw = Math.min(fw, fh * W / H);
    }
    kw = Math.min(kw, Math.max(fw, fh * W / H) * 1.15);
    var kh = kw * H / W;
    var kx = cx - kw / 2, ky = cy - kh * 0.42;
    var olcek = W / kw;

    var c = document.createElement('canvas');
    c.width = W; c.height = H;
    var ctx = c.getContext('2d', { willReadFrequently: true });
    ctx.fillStyle = '#000';
    ctx.fillRect(0, 0, W, H);
    ctx.imageSmoothingQuality = 'high';
    ctx.drawImage(img, kx, ky, kw, kh, 0, 0, W, H);
    var veri = ctx.getImageData(0, 0, W, H);
    var d = veri.data, N = W * H, i, x, y;

    var L = new Float32Array(N);
    for (i = 0; i < N; i++) L[i] = 0.299 * d[i * 4] + 0.587 * d[i * 4 + 1] + 0.114 * d[i * 4 + 2];

    // Kişi maskesi aynı kırpmayla 768×1120'ye (yumuşak kenar)
    var maske = null;
    if (hamMaske && hamMaske.w && hamMaske.h) {
      var mc = document.createElement('canvas');
      mc.width = hamMaske.w; mc.height = hamMaske.h;
      var mctx = mc.getContext('2d');
      var mid = mctx.createImageData(hamMaske.w, hamMaske.h);
      for (i = 0; i < hamMaske.veri.length; i++) {
        var mv = Math.round(hamMaske.veri[i] * 255);
        mid.data[i * 4] = mid.data[i * 4 + 1] = mid.data[i * 4 + 2] = mv; mid.data[i * 4 + 3] = 255;
      }
      mctx.putImageData(mid, 0, 0);
      var kc = document.createElement('canvas');
      kc.width = W; kc.height = H;
      var kctx = kc.getContext('2d', { willReadFrequently: true });
      kctx.fillStyle = '#000';
      kctx.fillRect(0, 0, W, H);
      kctx.drawImage(mc, kx * mc.width / fw, ky * mc.height / fh, kw * mc.width / fw, kh * mc.height / fh, 0, 0, W, H);
      var kd = kctx.getImageData(0, 0, W, H).data;
      maske = new Float32Array(N);
      for (i = 0; i < N; i++) maske[i] = kd[i * 4] / 255;
      maske = bulanik(maske, W, H, 3);
    }

    var kutular = yuzler.map(function (f) {
      var fx = (f.x - kx) * olcek, fy = (f.y - ky) * olcek, w = f.w * olcek, h = f.h * olcek;
      return { x: fx - w * 0.25, y: fy - h * 0.35, w: w * 1.5, h: h * 1.6, mx: fx + w / 2, my: fy + h / 2, r: Math.max(w, h) * 0.5 };
    });

    if (kutular.length) {
      // Her yüzü kendi içinde normalleştir (%3–97 → 40–220, en fazla %60 karışım)
      var hedef = new Float32Array(L), agirlik = new Float32Array(N);
      kutular.forEach(function (k) {
        var bx0 = Math.max(0, k.x | 0), by0 = Math.max(0, k.y | 0);
        var bx1 = Math.min(W, (k.x + k.w) | 0), by1 = Math.min(H, (k.y + k.h) | 0);
        var ornek = [];
        for (y = by0; y < by1; y += 2) for (x = bx0; x < bx1; x += 2) ornek.push(L[y * W + x]);
        var lo = yuzdelik(ornek, 0.03), hi = yuzdelik(ornek, 0.97), s = 180 / Math.max(30, hi - lo);
        for (y = by0; y < by1; y++) for (x = bx0; x < bx1; x++) {
          var ii = y * W + x;
          var dx = (x - k.mx) / (k.w * 0.6), dy = (y - k.my) / (k.h * 0.6);
          var wgt = 0.6 * Math.max(0, Math.min(1, 1.6 - Math.sqrt(dx * dx + dy * dy) * 1.6));
          if (wgt > agirlik[ii]) { agirlik[ii] = wgt; hedef[ii] = 40 + (L[ii] - lo) * s; }
        }
      });
      for (i = 0; i < N; i++) L[i] = L[i] * (1 - agirlik[i]) + hedef[i] * agirlik[i];

      // Maske yönü: yüz merkezlerinde düşükse ters çevrilir (model sürümüne göre arka plan olasılığı dönebilir)
      if (maske) {
        var ort = 0;
        kutular.forEach(function (k) { ort += maske[Math.min(H - 1, Math.max(0, k.my | 0)) * W + Math.min(W - 1, Math.max(0, k.mx | 0))]; });
        if (ort / kutular.length < 0.5) for (i = 0; i < N; i++) maske[i] = 1 - maske[i];
      }

      // Kişilerde: yüzlerden uzaklaştıkça karart (omuz/saç silüeti hafif kalır)
      for (y = 0; y < H; y++) for (x = 0; x < W; x++) {
        var yakin = 0;
        for (var q = 0; q < kutular.length; q++) {
          var kk = kutular[q];
          var ddx = (x - kk.mx) / (kk.r * 2.4), ddy = (y - kk.my) / (kk.r * 2.8);
          yakin = Math.max(yakin, 1 - Math.sqrt(ddx * ddx + ddy * ddy));
        }
        L[y * W + x] *= 0.25 + 0.75 * Math.max(0, Math.min(1, yakin * 1.8));
      }
    }

    // Arka plan (kişi maskesinin dışı): bulanık ve neredeyse siyah düz zemin
    if (maske) {
      var Lb = bulanik(L, W, H, W * 0.035);
      for (i = 0; i < N; i++) { var zemin = Lb[i] * 0.12; L[i] = zemin + (L[i] - zemin) * maske[i]; }
    }

    // İnce doku yalnız yüzlerde kalır: tel tel saç, fermuar, kıyafet kıvrımı modelde demir işi/süs olarak çıkıyor;
    // yüzlerin dışı yumuşatılır (silüet korunur)
    if (kutular.length) {
      var Ly = bulanik(L, W, H, W * 0.012);
      for (y = 0; y < H; y++) for (x = 0; x < W; x++) {
        var yw = 0;
        for (var q2 = 0; q2 < kutular.length; q2++) {
          var k2 = kutular[q2];
          var ex = (x - k2.mx) / (k2.w * 0.6), ey = (y - k2.my) / (k2.h * 0.6);
          yw = Math.max(yw, Math.max(0, Math.min(1, 1.6 - Math.sqrt(ex * ex + ey * ey) * 1.6)));
        }
        var j2 = y * W + x;
        L[j2] = Ly[j2] + (L[j2] - Ly[j2]) * yw;
      }
    }

    // Yerel kontrast, dört ton, hafif yumuşatma
    var B = bulanik(L, W, H, W * 0.02);
    for (i = 0; i < N; i++) L[i] = L[i] + (L[i] - B[i]) * 1.0;
    for (i = 0; i < N; i++) { var v = L[i]; L[i] = v < 55 ? 10 : v < 115 ? 85 : v < 175 ? 165 : 240; }
    L = bulanik(L, W, H, 2);

    for (i = 0; i < N; i++) { d[i * 4] = d[i * 4 + 1] = d[i * 4 + 2] = L[i]; d[i * 4 + 3] = 255; }
    ctx.putImageData(veri, 0, 0);
    return { canvas: c, kisiSayisi: yuzler.length, algilandi: bulunan !== null };
  }

  /* =====================================================================
     2) Stüdyo
     ===================================================================== */
  var SIMGE = {
    yukle: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><rect x="3" y="3" width="18" height="18" rx="3"/><circle cx="8.5" cy="9" r="1.8"/><path d="M21 15l-5-5L5 21"/></svg>',
    tekrar: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M21 12a9 9 0 1 1-2.64-6.36"/><path d="M21 3v6h-6"/></svg>',
    goz: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M2 12s3.6-6 10-6 10 6 10 6-3.6 6-10 6S2 12 2 12z"/><circle cx="12" cy="12" r="2.6"/></svg>',
  };

  var VARSAYILAN_METIN = {
    yukleBaslik: 'Fotoğrafını yükle',
    yukleAlt: 'Yüzlerin net göründüğü, 1–4 kişilik bir fotoğraf seç',
    fotoHazir: 'Fotoğrafın',
    degistir: 'Değiştir',
    kisiBulundu: '[n] kişi bulundu',
    yuzYok: 'Yüz bulamadık. Yüzlerin net ve büyük göründüğü bir fotoğraf daha iyi sonuç verir.',
    cokKisi: 'En iyi sonuç 1–4 kişide alınır; yine de deniyoruz.',
    tekrar: 'Tekrar dene',
    denemeler: 'Denemelerin — beğendiğini seç',
    goz: 'Gözlerini kısarak bak',
    gozAcik: 'Normal görünüm',
    galeri: 'Ürün fotoğraflarını göster',
    onizlemeyeDon: 'Tasarımıma dön',
    hazirlaniyor: ['Fotoğrafın inceleniyor', 'Yüzler tabloya gizleniyor', 'Fırça darbeleri ekleniyor', 'Son rötuşlar yapılıyor'],
    sure: 'Yaklaşık 20 saniye sürer, sayfadan ayrılma.',
    hazir: 'Tasarımın hazır! Uzaktan bak ya da gözlerini kıs.',
    once: 'Önce fotoğrafını yükle, tasarımın hazırlansın.',
    bekle: 'Tasarımın hazırlanıyor, birkaç saniye bekle.',
    acilamadi: 'Bu fotoğraf açılamadı. JPG veya PNG bir fotoğraf dene.',
    hata: 'Tasarım şu an oluşturulamadı, lütfen tekrar dene.',
    uzun: 'Beklenenden uzun sürdü, lütfen tekrar dene.',
    kvkk: 'Fotoğrafın cihazında işlenir; tasarım için yalnızca yüzlerden çıkarılan siyah-beyaz desen gönderilir.',
    kvkkLink: 'Aydınlatma Metni',
  };

  var RENKLER = [
    [/beyaz|white/i, 'beyaz'],
    [/siyah|black/i, 'siyah'],
    [/ceviz|walnut/i, 'ceviz'],
    [/ah[sş]ap|naturel|wood|me[sş]e/i, 'ahsap'],
    [/alt[ıi]n|gold/i, 'altin'],
  ];

  function el(etiket, sinif, html) {
    var e = document.createElement(etiket);
    if (sinif) e.className = sinif;
    if (html != null) e.innerHTML = html;
    return e;
  }
  function uyku(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }

  function Studyo(kok) {
    var ayarEl = kok.querySelector('[data-fso-gp-ayar]');
    var ayar = {};
    try { ayar = JSON.parse(ayarEl ? ayarEl.textContent : '{}'); } catch (e) { console.warn('[gizli-portre] ayar okunamadı', e); }
    this.kok = kok;
    this.ayar = ayar;
    this.api = String(ayar.api || '').replace(/\/+$/, '');
    this.m = Object.assign({}, VARSAYILAN_METIN, ayar.metinler || {});
    this.form = ayar.form ? document.querySelector(ayar.form) : kok.closest('form');
    this.sayfa = ayar.kok ? document.querySelector(ayar.kok) : document.body;
    this.medya = ayar.medya ? document.querySelector(ayar.medya) : null;
    this.denemeler = [];
    this.secili = null;
    this.kontrol = null;
    this.calisiyor = false;
    this.kur();
  }

  Studyo.prototype.kur = function () {
    var s = this, m = this.m;
    var kart = el('div', 'fso-gp');
    kart.innerHTML =
      '<label class="fso-gp-drop" data-gp-drop>' +
        '<input type="file" accept="image/*" class="fso-gp-file" data-gp-file>' +
        '<span class="fso-gp-drop-icon">' + SIMGE.yukle + '</span>' +
        '<span class="fso-gp-drop-title"></span>' +
        '<span class="fso-gp-drop-sub"></span>' +
      '</label>' +
      '<div class="fso-gp-photo" data-gp-photo hidden>' +
        '<img data-gp-photo-img alt="">' +
        '<span class="fso-gp-photo-text"><strong></strong><span data-gp-faces></span></span>' +
        '<button type="button" class="fso-gp-link" data-gp-change></button>' +
      '</div>' +
      '<div class="fso-gp-slot" data-gp-slot></div>' +
      '<div class="fso-gp-progress" data-gp-progress hidden>' +
        '<div class="fso-gp-bar"><i data-gp-bar></i></div>' +
        '<p class="fso-gp-progress-text"><strong data-gp-step></strong><span data-gp-sure></span></p>' +
      '</div>' +
      '<div class="fso-gp-history" data-gp-history hidden><p class="fso-gp-history-title"></p><div class="fso-gp-thumbs" data-gp-thumbs role="radiogroup"></div></div>' +
      '<div class="fso-gp-actions" data-gp-actions hidden>' +
        '<button type="button" class="fso-btn fso-btn--secondary fso-gp-retry" data-gp-retry>' + SIMGE.tekrar + '<span></span></button>' +
      '</div>' +
      '<p class="fso-gp-msg" data-gp-msg role="status" aria-live="polite"></p>' +
      '<p class="fso-gp-kvkk"><span></span>' + (this.ayar.kvkk ? ' <a target="_blank" rel="noopener"></a>' : '') + '</p>';
    kart.querySelector('.fso-gp-drop-title').textContent = m.yukleBaslik;
    kart.querySelector('.fso-gp-drop-sub').textContent = m.yukleAlt;
    kart.querySelector('.fso-gp-photo-text strong').textContent = m.fotoHazir;
    kart.querySelector('[data-gp-change]').textContent = m.degistir;
    kart.querySelector('.fso-gp-history-title').textContent = m.denemeler;
    kart.querySelector('[data-gp-retry] span').textContent = m.tekrar;
    kart.querySelector('[data-gp-sure]').textContent = m.sure;
    kart.querySelector('.fso-gp-kvkk span').textContent = m.kvkk;
    var kvkkA = kart.querySelector('.fso-gp-kvkk a');
    if (kvkkA) { kvkkA.href = this.ayar.kvkk; kvkkA.textContent = m.kvkkLink; }
    this.kok.appendChild(kart);
    this.kart = kart;
    this.$ = function (sec) { return kart.querySelector(sec); };

    // Sahne: çerçeveli önizleme (masaüstünde sol sütunda, mobilde kartın içinde)
    var sahne = el('div', 'fso-gp-stage');
    sahne.hidden = true;
    sahne.setAttribute('data-gp-stage', '');
    sahne.innerHTML =
      '<div class="fso-gp-wall">' +
        '<div class="fso-gp-frame" data-gp-frame>' +
          '<div class="fso-gp-art" data-gp-art>' +
            '<img data-gp-art-img alt="" hidden>' +
            '<div class="fso-gp-wait" data-gp-wait hidden><span class="fso-gp-shimmer"></span><span class="fso-gp-wait-text" data-gp-wait-text></span></div>' +
          '</div>' +
        '</div>' +
      '</div>' +
      '<div class="fso-gp-stage-bar">' +
        '<button type="button" class="fso-btn fso-btn--secondary fso-gp-squint" data-gp-squint aria-pressed="false" disabled>' + SIMGE.goz + '<span></span></button>' +
        '<button type="button" class="fso-gp-link fso-gp-gallery-link" data-gp-gallery hidden></button>' +
      '</div>';
    sahne.querySelector('[data-gp-squint] span').textContent = m.goz;
    sahne.querySelector('[data-gp-art-img]').alt = 'Tasarım önizlemesi';
    if (this.ayar.bulaniklik) sahne.style.setProperty('--gp-blur', this.ayar.bulaniklik + 'px');
    this.sahne = sahne;
    this.yerlestir();
    if (window.matchMedia) {
      var mq = window.matchMedia('(min-width: 1025px)');
      (mq.addEventListener ? mq.addEventListener.bind(mq, 'change') : mq.addListener.bind(mq))(function () { s.yerlestir(); });
    }

    // Olaylar
    var dosya = this.$('[data-gp-file]');
    var drop = this.$('[data-gp-drop]');
    dosya.addEventListener('change', function () { if (dosya.files && dosya.files[0]) s.fotoSec(dosya.files[0]); dosya.value = ''; });
    ['dragenter', 'dragover'].forEach(function (t) {
      drop.addEventListener(t, function (e) { e.preventDefault(); drop.classList.add('is-over'); });
    });
    ['dragleave', 'drop'].forEach(function (t) {
      drop.addEventListener(t, function () { drop.classList.remove('is-over'); });
    });
    drop.addEventListener('drop', function (e) {
      e.preventDefault();
      var f = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0];
      if (f) s.fotoSec(f);
    });
    // Yüz algılayıcıyı niyet anında yükle (dosya seçilirken arka planda iner)
    var onYukle = function () { algilayici(); ayirici(); };
    ['pointerdown', 'focusin', 'dragenter'].forEach(function (t) { kart.addEventListener(t, onYukle, { once: true, passive: true }); });

    this.$('[data-gp-change]').addEventListener('click', function () { dosya.click(); });
    this.$('[data-gp-retry]').addEventListener('click', function () { s.uret(); });
    sahne.querySelector('[data-gp-squint]').addEventListener('click', function () { s.kis(); });
    sahne.querySelector('[data-gp-gallery]').addEventListener('click', function () { s.galeriGoster(!s.galeriAcik); });

    // Çerçeve rengi
    this.renkGuncelle();
    document.addEventListener('click', function (e) {
      if (s.ayar.renk && e.target.closest && e.target.closest(s.ayar.renk.replace(/\.selected\b/, ''))) requestAnimationFrame(function () { s.renkGuncelle(); });
    });
    if (this.form) this.form.addEventListener('change', function () { s.renkGuncelle(); });

    // Sepete ekle: tasarım yoksa durdur; varsa baskı dosyasını hazırlamaya başla
    if (this.form) {
      this.girdiler = {};
      ['_tasarim_pdf', '_tasarim_onizleme', '_stil'].forEach(function (ad) {
        var g = s.form.querySelector('input[name="properties[' + ad + ']"]');
        if (!g) {
          g = document.createElement('input');
          g.type = 'hidden';
          g.name = 'properties[' + ad + ']';
          s.form.appendChild(g);
        }
        g.value = '';
        s.girdiler[ad] = g;
      });
      // Pencere düzeyinde yakalama: temanın (Horizon on:submit / on:click) ve yan sepet betiklerinin önünde çalışır.
      // Sabit alt çubuk ana düğmeye click() gönderdiği için o da buradan geçer.
      window.addEventListener('click', function (e) {
        var b = e.target && e.target.closest && e.target.closest('button[type="submit"], input[type="submit"]');
        if (b && b.form === s.form) s.gonderiliyor(e);
      }, true);
      window.addEventListener('submit', function (e) { if (e.target === s.form) s.gonderiliyor(e); }, true);
    }
  };

  // Sahne masaüstünde sol sütunun başında, mobilde kartın içinde
  Studyo.prototype.yerlestir = function () {
    var genis = window.matchMedia && window.matchMedia('(min-width: 1025px)').matches && this.medya;
    var hedef = genis ? this.medya : this.$('[data-gp-slot]');
    if (genis) {
      if (this.sahne.parentNode !== this.medya || this.medya.firstElementChild !== this.sahne) this.medya.insertBefore(this.sahne, this.medya.firstChild);
    } else if (this.sahne.parentNode !== hedef) {
      hedef.appendChild(this.sahne);
    }
    this.genis = !!genis;
    this.galeriGoster(false);
  };

  // Masaüstünde önizleme varken ürün galerisi gizlenir; bağlantıyla geri açılır
  Studyo.prototype.galeriGoster = function (acik) {
    this.galeriAcik = !!acik;
    var aktif = !this.sahne.hidden && this.genis;
    var galeri = this.ayar.galeri ? document.querySelector(this.ayar.galeri) : null;
    if (galeri) galeri.classList.toggle('fso-gp-hide', aktif && !this.galeriAcik);
    var art = this.sahne.querySelector('.fso-gp-wall');
    art.hidden = aktif && this.galeriAcik;
    var link = this.sahne.querySelector('[data-gp-gallery]');
    link.hidden = !(aktif && galeri);
    link.textContent = this.galeriAcik ? this.m.onizlemeyeDon : this.m.galeri;
    if (this.sayfa) this.sayfa.classList.toggle('is-gp-active', aktif);
  };

  Studyo.prototype.renkGuncelle = function () {
    var secili = this.ayar.renk ? document.querySelector(this.ayar.renk) : null;
    var deger = secili ? (secili.getAttribute('data-value') || secili.textContent || '') : '';
    var ad = 'siyah';
    for (var i = 0; i < RENKLER.length; i++) if (RENKLER[i][0].test(deger)) { ad = RENKLER[i][1]; break; }
    this.sahne.querySelector('[data-gp-frame]').setAttribute('data-renk', ad);
  };

  Studyo.prototype.mesaj = function (metin, tur) {
    var p = this.$('[data-gp-msg]');
    p.textContent = metin || '';
    p.classList.toggle('is-error', tur === 'hata');
  };

  Studyo.prototype.fotoSec = async function (dosya) {
    if (this.calisiyor) { this.mesaj(this.m.bekle); return; }
    if (!/^image\//.test(dosya.type || 'image/')) { this.mesaj(this.m.acilamadi, 'hata'); return; }
    this.mesaj('');
    var url = URL.createObjectURL(dosya);
    var img = new Image();
    img.src = url;
    try {
      await img.decode();
    } catch (e) {
      URL.revokeObjectURL(url);
      this.mesaj(this.m.acilamadi, 'hata');
      return;
    }
    // Büyük fotoğrafı küçült (hız ve bellek)
    var en = img.naturalWidth, boy = img.naturalHeight, k = Math.min(1, 1600 / Math.max(en, boy));
    var tuval = document.createElement('canvas');
    tuval.width = Math.round(en * k); tuval.height = Math.round(boy * k);
    tuval.getContext('2d').drawImage(img, 0, 0, tuval.width, tuval.height);

    var foto = this.$('[data-gp-photo]');
    var kucuk = this.$('[data-gp-photo-img]');
    if (this.fotoUrl) URL.revokeObjectURL(this.fotoUrl);
    this.fotoUrl = url;
    kucuk.src = url;
    foto.hidden = false;
    this.$('[data-gp-drop]').hidden = true;
    this.$('[data-gp-faces]').textContent = '';

    this.ilerleme(true, 0);
    this.sahneBekle(true);
    try {
      var sonuc = await desenHazirla(tuval);
      this.kontrol = sonuc.canvas.toDataURL('image/jpeg', 0.9);
      this.$('[data-gp-faces]').textContent = sonuc.kisiSayisi ? this.m.kisiBulundu.replace('[n]', sonuc.kisiSayisi) : '';
      if (sonuc.algilandi && !sonuc.kisiSayisi) this.mesaj(this.m.yuzYok);
      else if (sonuc.kisiSayisi > 4) this.mesaj(this.m.cokKisi);
    } catch (e) {
      console.warn('[gizli-portre] desen hazırlanamadı', e);
      this.ilerleme(false);
      this.sahneBekle(false);
      this.mesaj(this.m.acilamadi, 'hata');
      return;
    }
    this.uret(true);
  };

  Studyo.prototype.istek = async function (yol, govde) {
    var r = await fetch(this.api + yol, govde ? { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(govde) } : {});
    var veri = await r.json().catch(function () { return {}; });
    if (!r.ok) { var h = new Error(veri.hata || this.m.hata); h.sunucu = !!veri.hata; throw h; }
    return veri;
  };

  Studyo.prototype.uret = async function (ilk) {
    if (!this.kontrol) { this.$('[data-gp-file]').click(); return; }
    if (this.calisiyor) return;
    this.calisiyor = true;
    if (!ilk) this.mesaj('');
    this.$('[data-gp-retry]').disabled = true;
    this.ilerleme(true, 0);
    this.sahneBekle(true);
    var bas = Date.now();
    try {
      var r = await this.istek('/uret', { stil: this.ayar.stil, kontrol: this.kontrol });
      var d;
      for (;;) {
        await uyku(1500);
        d = await this.istek('/durum/' + r.id);
        if (d.durum === 'hazir') break;
        if (d.durum === 'hata') throw new Error(this.m.hata);
        if (Date.now() - bas > 150000) throw new Error(this.m.uzun);
      }
      await new Promise(function (tamam) { var on = new Image(); on.onload = on.onerror = tamam; on.src = d.onizleme; });
      var deneme = { id: r.id, onizleme: d.onizleme, pdf: this.api + '/dosya/pdf/' + r.id + '.pdf', stil: r.stil };
      this.denemeler.push(deneme);
      this.sec(deneme);
      this.mesaj(this.m.hazir);
    } catch (e) {
      console.warn('[gizli-portre]', e);
      this.mesaj(e && e.sunucu ? e.message : (e && e.message === this.m.uzun ? e.message : this.m.hata), 'hata');
    } finally {
      this.calisiyor = false;
      this.ilerleme(false);
      this.sahneBekle(false);
      this.$('[data-gp-retry]').disabled = false;
      this.$('[data-gp-actions]').hidden = false;
    }
  };

  Studyo.prototype.sec = function (deneme) {
    this.secili = deneme;
    var img = this.sahne.querySelector('[data-gp-art-img]');
    img.src = deneme.onizleme;
    img.hidden = false;
    this.sahne.hidden = false;
    this.sahne.querySelector('[data-gp-squint]').disabled = false;
    this.galeriGoster(false);
    if (this.girdiler) {
      this.girdiler._tasarim_pdf.value = deneme.pdf;
      this.girdiler._tasarim_onizleme.value = deneme.onizleme;
      this.girdiler._stil.value = deneme.stil || this.ayar.stil || '';
    }
    this.kucukResimler();
    // Mobilde çerçevenin tamamı ekranda değilse ortala (üstte menü, altta sabit sepet çubuğu var)
    if (!this.genis) {
      var r = this.sahne.getBoundingClientRect();
      if (r.top < 110 || r.bottom > window.innerHeight - 90) this.sahne.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  };

  Studyo.prototype.kucukResimler = function () {
    var s = this, kutu = this.$('[data-gp-thumbs]');
    this.$('[data-gp-history]').hidden = this.denemeler.length < 2;
    kutu.innerHTML = '';
    this.denemeler.forEach(function (d, i) {
      var b = el('button', 'fso-gp-thumb');
      b.type = 'button';
      b.setAttribute('role', 'radio');
      b.setAttribute('aria-checked', String(d === s.secili));
      b.setAttribute('aria-label', (i + 1) + '. deneme');
      var im = el('img');
      im.src = d.onizleme; im.alt = ''; im.loading = 'lazy';
      b.appendChild(im);
      b.addEventListener('click', function () { s.sec(d); });
      kutu.appendChild(b);
    });
  };

  // Tahmini ilerleme (sunucu ilerleme bildirmez): ~20 sn'de %90'a yaklaşır, bitince kapanır
  Studyo.prototype.ilerleme = function (acik, _) {
    var s = this, kutu = this.$('[data-gp-progress]'), bar = this.$('[data-gp-bar]'), adim = this.$('[data-gp-step]');
    clearInterval(this.sayac);
    kutu.hidden = !acik;
    if (!acik) return;
    var bas = Date.now(), adimlar = this.m.hazirlaniyor;
    var tik = function () {
      var t = (Date.now() - bas) / 1000;
      bar.style.width = (Math.min(0.95, 1 - Math.exp(-t / 9)) * 100).toFixed(1) + '%';
      var metin = adimlar[Math.min(adimlar.length - 1, Math.floor(t / 5))];
      adim.textContent = metin;
      var bt = s.sahne.querySelector('[data-gp-wait-text]');
      if (bt) bt.textContent = metin;
    };
    tik();
    this.sayac = setInterval(tik, 250);
  };

  Studyo.prototype.sahneBekle = function (acik) {
    var bekle = this.sahne.querySelector('[data-gp-wait]');
    bekle.hidden = !acik;
    if (acik) this.sahne.hidden = false;
    this.sahne.classList.toggle('is-busy', acik);
    if (acik && !this.secili) this.sahne.querySelector('[data-gp-art-img]').hidden = true;
    if (!acik && !this.secili) this.sahne.hidden = true;
    this.galeriGoster(this.galeriAcik && !acik);
  };

  // Gözünü kıs: yalnız tablonun içi bulanıklaşır (çerçeve keser)
  Studyo.prototype.kis = function () {
    var b = this.sahne.querySelector('[data-gp-squint]');
    var acik = !this.sahne.classList.contains('is-squint');
    this.sahne.classList.toggle('is-squint', acik);
    b.setAttribute('aria-pressed', String(acik));
    b.querySelector('span').textContent = acik ? this.m.gozAcik : this.m.goz;
  };

  Studyo.prototype.gonderiliyor = function (e) {
    var durdur = function () { e.preventDefault(); e.stopImmediatePropagation(); };
    if (this.calisiyor) { durdur(); this.mesaj(this.m.bekle); this.goster(); return; }
    if (!this.secili) { durdur(); this.mesaj(this.m.once, 'hata'); this.goster(); return; }
    // Seçili tasarımın 4× büyütülmesi + PDF'i hemen başlar (bağlantı zaten kalıcı; açıldığında da kendini tamamlar)
    if (this.secili.secildi) return;
    this.secili.secildi = true;
    try {
      fetch(this.api + '/sec', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: this.secili.id }), keepalive: true }).catch(function () {});
    } catch (_) { /* yoksay */ }
  };

  Studyo.prototype.goster = function () {
    var kart = this.kok.closest('[data-fso-custom]') || this.kok;
    var ofset = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--fso-header-sticky-h'), 10) || 0;
    var ust = kart.getBoundingClientRect().top + window.scrollY - ofset - 12;
    window.scrollTo({ top: Math.max(0, ust), behavior: 'smooth' });
    kart.classList.remove('is-need');
    void kart.offsetWidth;
    kart.classList.add('is-need');
  };

  function baslat() {
    document.querySelectorAll('[data-fso-gp]').forEach(function (kok) {
      if (kok.__fsoGp) return;
      kok.__fsoGp = new Studyo(kok);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', baslat);
  else baslat();
  window.FsoGizliPortre = { baslat: baslat, desenHazirla: desenHazirla };
})();
